import { LOGGER } from "../utils/logger";
import useAxios from "../utils/interceptor";

const UserApi = () => {
  const axiosHandler = useAxios();

  const getAll = async ({
    page = 0,
    pageSize = 10,
    type = "ALL",
    companyId = "",
    search = "",
  }) => {
    try {
      const res = await axiosHandler.get(
        `user/?page=${page}&pageSize=${pageSize}&type=${type}&companyId=${companyId}&search=${search}`
      );
      return res?.data;
    } catch (error) {
      LOGGER.error({ text: "Get All Api", error });
    }
  };

  const getDesigner = async () => {
    try {
      const res = await axiosHandler.get(`user/get-admin-designers`);
      return res?.data;
    } catch (error) {
      LOGGER.error({ text: "Get All Designer Api", error });
    }
  };

  const create = async (body) => {
    try {
      const res = await axiosHandler.post(`user/signup-user`, body);
      return res;
    } catch (error) {
      LOGGER.error({ text: "Create User Api", error });
      return {
        text: "create api error",
        error,
      };
    }
  };

  const createAdmin = async (body) => {
    try {
      const res = await axiosHandler.post(`user/signup-admin`, body);
      return res;
    } catch (error) {
      LOGGER.error({ text: "Create User Api", error });
      return {
        text: "create api error",
        error,
      };
    }
  };

  const update = async (body, id) => {
    try {
      const res = await axiosHandler.put(`user/${id}`, body);
      return res;
    } catch (error) {
      LOGGER.error({ text: "Update User Api", error });
    }
  };

  const userLogin = async (body) => {
    try {
      const res = await axiosHandler.post(`user/login`, body);
      return res;
    } catch (error) {
      LOGGER.error({ text: "User Login", error });
      return {
        text: "User Login Error",
        error,
      };
    }
  };

  const resetPassword = async (body) => {
    try {
      const res = await axiosHandler.post(`user/reset-password`, body);
      return res;
    } catch (error) {
      LOGGER.error({ text: "Reset User Password", error });
      return {
        text: "Reset User Password error",
        error,
      };
    }
  };

  const getDetails = async () => {
    try {
      const res = await axiosHandler.get(`user/get-detail`);
      return res?.data;
    } catch (error) {
      LOGGER.error({ text: "Get Info Error", error });
      return {
        text: "Get Info Error",
        error,
      };
    }
  };

  const remove = async (id) => {
    try {
      const res = await axiosHandler.delete(`user/${id}`);
      return res;
    } catch (error) {
      return {
        text: "Remove Info Error",
        error,
      };
    }
  };

  const forgetPasswordSend = async ({ email = "" }) => {
    try {
      const res = await axiosHandler.get(`user/forgot-password?email=${email}`);
      return res;
    } catch (error) {
      LOGGER.error({ text: "Email Sent Error", error });
      return {
        text: "Email Sent Error",
        error,
      };
    }
  };

  const forgetPassword = async (body) => {
    try {
      const res = await axiosHandler.post(`user/forgot-password`, body);
      return res;
    } catch (error) {
      LOGGER.error({ text: "Password Update Error", error });
      return {
        text: "Password Update Error",
        error,
      };
    }
  };

  return {
    userLogin,
    getAll,
    getDesigner,
    create,
    update,
    resetPassword,
    createAdmin,
    getDetails,
    remove,
    forgetPasswordSend,
    forgetPassword
  };
};

export default UserApi;
